import React from 'react'
import { ScanTemplate } from '@/components/ScanTemplate'

interface ScanQRCodeProps {
  onScanResult: (result: string) => void
  onRejectPermission?: () => void
}

export const ScanQRCode: React.FC<ScanQRCodeProps> = ({
  onScanResult,
  onRejectPermission,
}) => {
  const handleRejectPermission = () => {
    onRejectPermission?.()
  }

  return (
    <ScanTemplate
      onBarcodeScanned={onScanResult}
      onRejectAccessCameraPermission={handleRejectPermission}
    />
  )
}
